import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function TestPhaseIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 13.75C19.9141 13.7502 20.25 14.0859 20.25 14.5V17C20.25 18.7948 18.7948 20.2498 17 20.25H13.667C13.2528 20.25 12.917 19.9142 12.917 19.5C12.917 19.0858 13.2528 18.75 13.667 18.75H17C17.9664 18.7498 18.75 17.9664 18.75 17V14.5C18.75 14.0859 19.0859 13.7502 19.5 13.75Z"
        fill="currentColor"
      />
      <path
        d="M8.76074 14.5518C9.05364 14.2589 9.5284 14.2589 9.82129 14.5518C10.1139 14.8447 10.1141 15.3195 9.82129 15.6123L8.57129 16.8623C8.52054 16.913 8.46212 16.9512 8.40234 16.9844C8.37832 16.9977 8.35513 17.012 8.33008 17.0225C8.31327 17.0295 8.2955 17.0333 8.27832 17.0391C8.25114 17.0482 8.22415 17.0566 8.19629 17.0625C8.17295 17.0674 8.14961 17.0705 8.12598 17.0732C8.10543 17.0756 8.0851 17.0784 8.06445 17.0791C8.03993 17.0799 8.0157 17.0778 7.99121 17.0762C7.96635 17.0745 7.94162 17.0734 7.91699 17.0693C7.89748 17.0661 7.87863 17.0605 7.85938 17.0557C7.83436 17.0494 7.80955 17.043 7.78516 17.0342C7.7635 17.0263 7.74268 17.0168 7.72168 17.0068C7.70037 16.9968 7.67966 16.9858 7.65918 16.9736C7.60687 16.9425 7.55578 16.9073 7.51074 16.8623L6.67676 16.0283L6.625 15.9717C6.38505 15.6771 6.40239 15.2423 6.67676 14.9678C6.95124 14.6933 7.38609 14.6761 7.68066 14.916L7.7373 14.9678L8.04102 15.2715L8.76074 14.5518Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.91602 11.25C11.4806 11.2502 12.7488 12.5185 12.749 14.083V15.4199L12.7441 15.6367C12.6492 17.7912 11.1428 19.6288 9.04883 20.1445L8.83789 20.1914C8.54674 20.2496 8.2485 20.2644 7.9541 20.2354L7.66113 20.1914C5.45782 19.7507 3.85205 17.863 3.75391 15.6367L3.74902 15.4199V14.083C3.7492 12.5185 5.01755 11.2503 6.58203 11.25H9.91602ZM6.58203 12.75C5.84598 12.7503 5.2492 13.3469 5.24902 14.083V15.4199L5.26172 15.7188C5.39204 17.1935 6.4803 18.4257 7.95508 18.7207L8.10156 18.7432C8.24865 18.7577 8.3975 18.7498 8.54297 18.7207C10.0178 18.4257 11.106 17.1935 11.2363 15.7188L11.249 15.4199V14.083C11.2488 13.3469 10.6521 12.7502 9.91602 12.75H6.58203Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.958 3.75C18.0981 3.75 19.833 5.4849 19.833 7.625C19.833 8.42373 19.5909 9.16551 19.1768 9.78223L20.0303 10.6357L20.082 10.6924C20.3224 10.9869 20.3047 11.4216 20.0303 11.6963C19.7556 11.971 19.321 11.9885 19.0264 11.748L18.9697 11.6963L18.1162 10.8428C17.4993 11.2573 16.7571 11.5 15.958 11.5C13.8181 11.4998 12.083 9.76499 12.083 7.625C12.083 5.48501 13.8181 3.75018 15.958 3.75ZM15.958 5.25C14.6465 5.25018 13.583 6.31344 13.583 7.625C13.583 8.93656 14.6465 9.99982 15.958 10C16.6123 10 17.2042 9.73461 17.6338 9.30664L17.6377 9.30371L17.6406 9.2998C18.0682 8.87031 18.333 8.27894 18.333 7.625C18.333 6.31332 17.2697 5.25 15.958 5.25Z"
        fill="currentColor"
      />
      <path
        d="M10.4102 3.75391C10.7883 3.79238 11.083 4.11172 11.083 4.5C11.083 4.88828 10.7883 5.20762 10.4102 5.24609L10.333 5.25H7C6.03351 5.25 5.25 6.0335 5.25 7V9.5C5.25 9.91421 4.91421 10.25 4.5 10.25C4.08579 10.25 3.75 9.91421 3.75 9.5V7C3.75 5.20508 5.20508 3.75 7 3.75H10.333L10.4102 3.75391Z"
        fill="currentColor"
      />
    </svg>
  );
};
